/* The Nerd Agenda — theme scripts (no dependencies) */
(function () {
  'use strict';

  var money = function (cents) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-CA', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'CAD' }).format(cents / 100);
    } catch (e) { return '$' + (cents / 100).toFixed(2); }
  };

  /* ---------- Toast ---------- */
  var toastTimer;
  function toast(html) {
    var el = document.querySelector('[data-na-toast]');
    if (!el) return;
    el.innerHTML = html;
    el.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.hidden = true; }, 4500);
  }

  /* ---------- Cart count ---------- */
  function setCartCount(n) {
    document.querySelectorAll('[data-na-cart-count]').forEach(function (el) {
      el.textContent = n;
      el.hidden = !n;
    });
  }
  function refreshCartCount() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { setCartCount(c.item_count); return c; })
      .catch(function () {});
  }

  /* ---------- Mobile menu ---------- */
  document.addEventListener('click', function (e) {
    var burger = e.target.closest('[data-na-burger]');
    if (burger) {
      var panel = document.querySelector('[data-na-mobile]');
      var open = panel.hidden;
      panel.hidden = !open;
      burger.setAttribute('aria-expanded', String(open));
      document.documentElement.classList.toggle('na-menu-open', open);
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      var panel = document.querySelector('[data-na-mobile]');
      if (panel && !panel.hidden) {
        panel.hidden = true;
        document.documentElement.classList.remove('na-menu-open');
        var b = document.querySelector('[data-na-burger]');
        if (b) { b.setAttribute('aria-expanded', 'false'); b.focus(); }
      }
    }
  });

  /* ---------- Ajax add to cart ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-na-product-form]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('[data-na-add]');
    var label = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
    fetch('/cart/add.js', { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
      .then(function (res) {
        if (!res.ok) { throw new Error(res.body.description || res.body.message || 'Could not add to cart.'); }
        toast('Added to cart! <a href="/cart">View cart</a>');
        return refreshCartCount();
      })
      .catch(function (err) { toast(err.message); })
      .then(function () { if (btn) { btn.disabled = false; btn.textContent = label; } });
  });

  /* ---------- Product page: gallery + variants ---------- */
  function initProduct(root) {
    var dataEl = root.querySelector('[data-na-product-json]');
    if (!dataEl) return;
    var product = JSON.parse(dataEl.textContent);

    // gallery thumbs
    var main = root.querySelector('[data-na-main-image]');
    root.querySelectorAll('[data-na-thumb]').forEach(function (t) {
      t.addEventListener('click', function () {
        if (main) { main.src = t.dataset.large; main.alt = t.dataset.alt || ''; }
        root.querySelectorAll('[data-na-thumb]').forEach(function (x) { x.classList.remove('is-active'); });
        t.classList.add('is-active');
      });
    });

    // variants
    var selects = root.querySelectorAll('[data-na-option]');
    var idInput = root.querySelector('[data-na-variant-id]');
    var priceEl = root.querySelector('[data-na-price]');
    var addBtn = root.querySelector('[data-na-add]');
    if (!selects.length || !idInput) return;

    function update() {
      var chosen = Array.prototype.map.call(selects, function (s) { return s.value; });
      var v = product.variants.filter(function (x) {
        return chosen.every(function (c, i) { return x.options[i] === c; });
      })[0];
      if (!v) {
        if (addBtn) { addBtn.disabled = true; addBtn.textContent = 'Unavailable'; }
        return;
      }
      idInput.value = v.id;
      if (priceEl) {
        priceEl.innerHTML = (v.compare_at_price && v.compare_at_price > v.price ? '<span class="na-price__compare">' + money(v.compare_at_price) + '</span>' : '') + money(v.price);
      }
      if (addBtn) {
        addBtn.disabled = !v.available;
        addBtn.textContent = v.available ? 'Add to Cart' : 'Sold Out';
      }
      if (v.featured_image && main) { main.src = v.featured_image.src; }
      var u = new URL(window.location.href);
      u.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', u);
    }
    selects.forEach(function (s) { s.addEventListener('change', update); });
  }
  document.querySelectorAll('[data-na-product]').forEach(initProduct);

  /* ---------- Cart page + collection filters: auto-submit ---------- */
  document.addEventListener('change', function (e) {
    if (e.target.matches('[data-na-qty]')) {
      var form = e.target.closest('form');
      if (form && form.requestSubmit) form.requestSubmit(form.querySelector('[name="update"]'));
      else if (form) form.submit();
    }
    if (e.target.closest('[data-na-filter-form]') && !e.target.matches('[data-na-no-auto]')) {
      e.target.closest('form').submit();
    }
  });

  /* ---------- Product recommendations (section rendering) ---------- */
  document.querySelectorAll('[data-na-recs]').forEach(function (el) {
    fetch(el.dataset.url).then(function (r) { return r.text(); }).then(function (html) {
      var tmp = document.createElement('div');
      tmp.innerHTML = html;
      var inner = tmp.querySelector('[data-na-recs-inner]');
      if (inner && inner.children.length) { el.innerHTML = inner.innerHTML; el.hidden = false; }
    }).catch(function () {});
  });

  refreshCartCount();
})();